import React from 'react';

export const ContentRegisterContext = React.createContext({});

export const useContentRegisterContext = () =>
  React.useContext(ContentRegisterContext);
